import {
  CheckCircleOutlined,
  EditOutlined,
  StopOutlined,
  PlusOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message, Table } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarPeriodo from "./AgregarPeriodo/AgregarPeriodo";
import EditarPeriodo from "./EditarPeriodo/EditarPeriodo";
import GenerarPeriodos from "./GenerarPeriodos/GenerarPeriodos";

moment.locale("es");

const MESES = [
  "", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

class Periodos extends Component {
  state = {
    arbol: [],
    loading: false,
    valor: 1,
    expandedKeys: [],
    tiposPeriodoMap: {},
    modalAgregarPeriodo: false,
    modalAgregarTipoPeriodoId: null,
    modalAgregarTipoPeriodo: null,
    modalEditarPeriodo: false,
    modalEditarPeriodoId: null,
    modalGenerarPeriodos: false,
    modalGenerarTipoPeriodoId: null,
    modalGenerarNombre: null,
    modalGenerarDiasPeriodo: null,
    modalGenerarFechaInicioEjercicio: null,
    modalGenerarFechaInicio: null,
    modalGenerarFechaFin: null,
  };

  componentDidMount() {
    this.consultarPeriodos();
  }

  consultarPeriodos() {
    this.setState({ loading: true });
    axios
      .post(
        "periodos/selectTodasPeriodos",
        { empresaId: this.props.empresaId, valor: this.state.valor },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ arbol: [] });
        } else {
          const arbol = res.data.data;
          const expandedKeys = arbol.map((t) => t.key);
          const tiposPeriodoMap = {};
          arbol.forEach((tipo) => {
            tiposPeriodoMap[String(tipo.tipoPeriodoId)] = {
              diasDePago: tipo.diasDePago,
              diasSeptimos: tipo.diasSeptimos,
              diasPeriodo: tipo.diasPeriodo,
              posisionSeptimoDia: tipo.posisionSeptimoDia,
            };
          });
          this.setState({ arbol, expandedKeys, tiposPeriodoMap });
        }
      });
  }

  deshabilitarPeriodo(periodoId) {
    axios
      .post(
        "periodos/deshabilitarPeriodo",
        { periodoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Periodo deshabilitado");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        this.consultarPeriodos();
      });
  }

  habilitarPeriodo(periodoId) {
    axios
      .post(
        "periodos/habilitarPeriodo",
        { periodoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Periodo habilitado");
        } else {
          message.error("Sucedió un error y no se pudo habilitar");
        }
        this.consultarPeriodos();
      });
  }

  // Deshabilita/habilita en bloque todos los periodos de un tipo de periodo
  // (renglón de tipo) o de un ejercicio (renglón de año). Actúa sobre todos los
  // periodos del grupo, no solo sobre los que muestra el filtro actual.
  cambiarEstadoMasivo(record, estado) {
    const esTipo = !!record.esTipoPeriodo;
    axios
      .post(
        "periodos/cambiarEstadoPeriodosMasivo",
        {
          empresaId: this.props.empresaId,
          tipoPeriodoId: esTipo ? record._id : record.tipoPeriodoId,
          alcance: esTipo ? "tipoPeriodo" : "ejercicio",
          ejercicio: esTipo
            ? undefined
            : record.ejercicio === "Sin ejercicio"
            ? null
            : Number(record.ejercicio),
          estado,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.error("Sucedió un error y no se pudo completar la acción");
        } else {
          const modificados = res.data.modificados || 0;
          const omitidos = res.data.omitidos || 0;
          if (modificados === 0 && omitidos === 0) {
            message.info("No hubo periodos que cambiar");
          } else {
            message.success(
              `${modificados} periodo(s) ${estado === 2 ? "deshabilitado(s)" : "habilitado(s)"}`
            );
          }
          if (omitidos > 0) {
            message.warning(`${omitidos} periodo(s) se omitieron por tener prenómina activa`);
          }
        }
        this.consultarPeriodos();
      });
  }

  agregarPeriodo(tipoPeriodoId) {
    this.setState({
      modalAgregarPeriodo: true,
      modalAgregarTipoPeriodoId: tipoPeriodoId,
      modalAgregarTipoPeriodo: this.state.tiposPeriodoMap[String(tipoPeriodoId)] || null,
    });
  }

  cerrarAgregarPeriodo() {
    this.setState({ modalAgregarPeriodo: false, modalAgregarTipoPeriodoId: null, modalAgregarTipoPeriodo: null });
    this.consultarPeriodos();
  }

  // Abre el generador en lote proponiendo continuar donde se quedó el tipo:
  // desde el día siguiente al último periodo que tiene, y un año hacia adelante.
  generarPeriodos(tipoPeriodoId) {
    const tipo = this.state.arbol.find(
      (t) => String(t.tipoPeriodoId) === String(tipoPeriodoId)
    );

    let ultimaFechaFin = null;
    (tipo?.ejercicios || []).forEach((ejercicio) => {
      (ejercicio.periodos || []).forEach((periodo) => {
        if (!periodo.fechaFin) return;
        const fin = moment(periodo.fechaFin);
        if (!ultimaFechaFin || fin.isAfter(ultimaFechaFin)) ultimaFechaFin = fin;
      });
    });

    // El día siguiente al último periodo ya es un arranque válido de la rejilla;
    // el modal termina de ajustar las dos fechas a los días que sí se pueden
    // elegir antes de precargarlas.
    const fechaInicio = ultimaFechaFin
      ? ultimaFechaFin.clone().startOf("day").add(1, "day")
      : moment().startOf("day");

    this.setState({
      modalGenerarPeriodos: true,
      modalGenerarTipoPeriodoId: tipoPeriodoId,
      modalGenerarNombre: tipo?.nombre || null,
      modalGenerarDiasPeriodo: tipo?.diasPeriodo ?? null,
      modalGenerarFechaInicioEjercicio: tipo?.fechaInicioEjercicio || null,
      modalGenerarFechaInicio: fechaInicio,
      modalGenerarFechaFin: fechaInicio.clone().add(1, "year"),
    });
  }

  cerrarGenerarPeriodos() {
    this.setState({
      modalGenerarPeriodos: false,
      modalGenerarTipoPeriodoId: null,
      modalGenerarNombre: null,
      modalGenerarDiasPeriodo: null,
      modalGenerarFechaInicioEjercicio: null,
      modalGenerarFechaInicio: null,
      modalGenerarFechaFin: null,
    });
    this.consultarPeriodos();
  }

  editarPeriodo(id) {
    this.setState({ modalEditarPeriodo: true, modalEditarPeriodoId: id });
  }

  cerrarEditarPeriodo() {
    this.setState({ modalEditarPeriodo: false, modalEditarPeriodoId: null });
    this.consultarPeriodos();
  }

  // Aplanar el árbol para el Table con children
  construirDataSource(arbol) {
    return arbol.map((tipo) => ({
      key: tipo.key,
      _id: tipo.tipoPeriodoId,
      esTipoPeriodo: true,
      nombre: tipo.nombre,
      totalPeriodos: tipo.totalPeriodos,
      children: tipo.ejercicios.map((ejercicioNode) => ({
        key: ejercicioNode.key,
        esEjercicio: true,
        tipoPeriodoId: ejercicioNode.tipoPeriodoId,
        ejercicio: ejercicioNode.ejercicio,
        nombre: String(ejercicioNode.ejercicio),
        children: ejercicioNode.periodos.map((periodo) => ({
          key: periodo._id.toString(),
          _id: periodo._id,
          esPeriodo: true,
          numero: periodo.numero,
          serie: periodo.serie,
          fechaInicio: periodo.fechaInicio,
          fechaFin: periodo.fechaFin,
          fechaPago: periodo.fechaPago,
          mes: periodo.mes,
          diasDePago: periodo.diasDePago,
          inicioMes: periodo.inicioMes,
          inicioBimestreIMSS: periodo.inicioBimestreIMSS,
          inicioEjercicio: periodo.inicioEjercicio,
          finMes: periodo.finMes,
          finBimestreIMSS: periodo.finBimestreIMSS,
          finEjercicio: periodo.finEjercicio,
          estado: periodo.estado,
        })),
      })),
    }));
  }

  render() {
    const dataSource = this.construirDataSource(this.state.arbol);

    const columns = [
      {
        title: "Periodo / Ejercicio / Detalle",
        dataIndex: "nombre",
        key: "nombre",
        render: (value, record) => {
          if (record.esTipoPeriodo) {
            return (
              <span style={{ fontWeight: 700, fontSize: 14 }}>
                {value}
                <Tag color="blue" style={{ marginLeft: 8 }}>
                  {record.totalPeriodos} periodos
                </Tag>
              </span>
            );
          }
          if (record.esEjercicio) {
            return (
              <span style={{ fontWeight: 600, color: "#595959" }}>
                Ejercicio {value}
              </span>
            );
          }
          // Fila de periodo
          const inicio = record.fechaInicio
            ? moment(record.fechaInicio).format("DD/MMM/YYYY")
            : "—";
          const fin = record.fechaFin
            ? moment(record.fechaFin).format("DD/MMM/YYYY")
            : "—";
          return (
            <span>
              <b>{record.serie}-{record.numero}</b>
              {" · "}
              {inicio} — {fin}
              {record.mes ? <Tag style={{ marginLeft: 6 }}>{MESES[record.mes]}</Tag> : null}
            </span>
          );
        },
      },
      {
        title: "Fecha Pago",
        dataIndex: "fechaPago",
        key: "fechaPago",
        width: "10%",
        render: (value, record) => {
          if (!record.esPeriodo) return null;
          return value ? moment(value).format("DD/MMM/YYYY") : "—";
        },
      },
      {
        title: "Días de Pago",
        dataIndex: "diasDePago",
        key: "diasDePago",
        width: "8%",
        render: (value, record) => (!record.esPeriodo ? null : value ?? "—"),
      },
      {
        title: "Indicadores",
        key: "indicadores",
        width: "16%",
        render: (_, record) => {
          if (!record.esPeriodo) return null;
          return (
            <span style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
              {record.inicioMes && <Tag color="cyan">Ini. Mes</Tag>}
              {record.finMes && <Tag color="cyan">Fin Mes</Tag>}
              {record.inicioEjercicio && <Tag color="purple">Ini. Ejercicio</Tag>}
              {record.finEjercicio && <Tag color="purple">Fin Ejercicio</Tag>}
              {record.inicioBimestreIMSS && <Tag color="orange">Ini. Bim.</Tag>}
              {record.finBimestreIMSS && <Tag color="orange">Fin Bim.</Tag>}
            </span>
          );
        },
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value, record) => {
          if (!record.esPeriodo) return null;
          if (value === 0) return <Tag color="red">Cancelado</Tag>;
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        key: "accion",
        width: "10%",
        render: (_, record) => {
          // Filas de agrupación (tipo de periodo / ejercicio): agregar periodo
          // + deshabilitar/habilitar todo el grupo
          if (record.esTipoPeriodo || record.esEjercicio) {
            const esTipo = !!record.esTipoPeriodo;
            const alcanceTexto = esTipo
              ? "de este tipo de periodo, de todos los ejercicios"
              : record.ejercicio === "Sin ejercicio"
              ? "sin ejercicio asignado"
              : `del ejercicio ${record.nombre}`;

            return (
              <div className="acciones-container">
                <Tooltip
                  key={`agregar-${record.key}`}
                  title={esTipo ? "Agregar Periodo" : "Agregar Periodo en este ejercicio"}
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type={esTipo ? "primary" : "default"}
                    size="small"
                    icon={<PlusOutlined />}
                    onClick={() =>
                      this.agregarPeriodo(esTipo ? record._id : record.tipoPeriodoId)
                    }
                  />
                </Tooltip>
                {esTipo && (
                  <Tooltip
                    key={`generar-${record.key}`}
                    title="Generar Periodos entre dos fechas"
                    placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      cyan
                      icon={<CalendarOutlined />}
                      onClick={() => this.generarPeriodos(record._id)}
                    />
                  </Tooltip>
                )}
                <Popconfirm
                  key={`deshabilitarTodos-${record.key}`}
                  title={`¿Deshabilitar TODOS los periodos ${alcanceTexto}?`}
                  onConfirm={() => this.cambiarEstadoMasivo(record, 2)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip
                    title="Deshabilitar todos los periodos"
                    placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                  >
                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
                <Popconfirm
                  key={`habilitarTodos-${record.key}`}
                  title={`¿Habilitar TODOS los periodos ${alcanceTexto}?`}
                  onConfirm={() => this.cambiarEstadoMasivo(record, 1)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip
                    title="Habilitar todos los periodos"
                    placement="top"
                    overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                  >
                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              </div>
            );
          }

          // Fila periodo: editar + habilitar/deshabilitar
          const buttons = [];

          buttons.push(
            <Tooltip
              key={`editar-${record._id}`}
              title="Editar Periodo"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.editarPeriodo(record._id)}
              />
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este periodo?"
                onConfirm={() => this.deshabilitarPeriodo(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Deshabilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este periodo?"
                onConfirm={() => this.habilitarPeriodo(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Habilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Periodos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Vigente", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    this.setState({ valor: value }, () => this.consultarPeriodos());
                  }}
                  value={this.state.valor}
                />
              )}
            </>
          }
        />
        <Table
          loading={this.state.loading}
          dataSource={dataSource}
          columns={columns}
          size="small"
          pagination={false}
          expandable={{
            expandedRowKeys: this.state.expandedKeys,
            onExpand: (expanded, record) => {
              const keys = expanded
                ? [...this.state.expandedKeys, record.key]
                : this.state.expandedKeys.filter((k) => k !== record.key);
              this.setState({ expandedKeys: keys });
            },
          }}
          scroll={{ x: "max-content" }}
          onRow={(record) => ({
            onDoubleClick: () => {
              if (record.esPeriodo) this.editarPeriodo(record._id);
            },
          })}
        />
        <AgregarPeriodo
          visible={this.state.modalAgregarPeriodo}
          tipoPeriodoId={this.state.modalAgregarTipoPeriodoId}
          tipoPeriodo={this.state.modalAgregarTipoPeriodo}
          cerrarAgregarPeriodo={this.cerrarAgregarPeriodo.bind(this)}
        />
        <EditarPeriodo
          visible={this.state.modalEditarPeriodo}
          periodoId={this.state.modalEditarPeriodoId}
          cerrarEditarPeriodo={this.cerrarEditarPeriodo.bind(this)}
        />
        <GenerarPeriodos
          visible={this.state.modalGenerarPeriodos}
          tipoPeriodoId={this.state.modalGenerarTipoPeriodoId}
          nombreTipoPeriodo={this.state.modalGenerarNombre}
          diasPeriodo={this.state.modalGenerarDiasPeriodo}
          fechaInicioEjercicio={this.state.modalGenerarFechaInicioEjercicio}
          fechaInicioSugerida={this.state.modalGenerarFechaInicio}
          fechaFinSugerida={this.state.modalGenerarFechaFin}
          cerrarGenerarPeriodos={this.cerrarGenerarPeriodos.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Periodos);